<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2" v-text="Title" />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div class="card mt-2">
            <div class="customer-info box-shadow">
              <b-container fluid>
                <b-row class="py-1 px-2 activites-bar">
                  <b-col md="3">Name & Description</b-col>
                  <b-col>Activated on</b-col>
                  <b-col>Due before</b-col>
                  <b-col>Department</b-col>
                  <b-col>Counts</b-col>
                  <b-col>Last count</b-col>
                  <b-col></b-col>
                </b-row>
                <div class="customer-data">
                  <b-row
                    class="py-3 px-4 align-items-center"
                    v-for="info in auditDetails"
                    :key="info.id"
                  >
                    <b-col md="3">
                      <span v-text="info.name" />
                      <br />
                      <span
                        class="description"
                        v-text="info.description"
                      ></span>
                    </b-col>
                    <b-col v-text="info.activated_on" />
                    <b-col v-text="info.due_on" />
                    <b-col>
                      <p
                        v-if="info.department_list.length === 1"
                        v-text="info.department_list[0]"
                        class="mb-0"
                      />
                      <p v-if="info.department_list.length > 1" class="mb-0">
                        {{ info.department_list[0] }} +{{
                          info.department_list.length - 1
                        }}
                        more
                      </p>
                    </b-col>
                    <b-col>
                      <span
                        :class="[
                          info.total_stockpoints_counts === 0
                            ? 'text-muted'
                            : null,
                        ]"
                        v-text="info.total_stockpoints_counts"
                      />
                    </b-col>
                    <b-col v-text="info.last_count" />
                    <b-col class="text-center">
                      <b-button
                        class="primary-btn w-100"
                        v-if="info.status == 'F' || info.status == 'C'"
                        @click="stockAudit(info)"
                        :disabled="info.status == 'C'"
                        :id="info.id"
                        :style="
                          info.status == 'C'
                            ? 'cursor: default; pointer-events: none'
                            : null
                        "
                        variant="outline-primary"
                      >
                        <span
                          v-if="$loading == false"
                          v-text="info.status == 'C' ? 'Completed' : 'Resume'"
                        />
                        <b-spinner small v-if="$loading" />
                      </b-button>
                      <b-button
                        class="w-100"
                        variant="primary"
                        @click="stockAudit(info)"
                        v-if="info.status == 'A'"
                        :id="info.id"
                      >
                        <span v-if="!$loading">Start</span>
                        <b-spinner small v-else />
                      </b-button>
                    </b-col>
                  </b-row>
                  <div
                    v-if="auditDetails.length == 0 && !$loading"
                    class="d-flex align-items-center justify-content-center"
                    style="height: 86vh;"
                  >
                    <p class="text-muted">
                      No active stock audits found. Please check again later.
                    </p>
                  </div>
                </div>
              </b-container>
            </div>
            <div class="clearfix"></div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import db from "../database";

export default {
  name: "stock-audit",
  components: {
    Dashboard,
    Loading,
  },
  created() {
    this.fetchAuditPlansList();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    vendorDetails() {
      return this.$store.getters["sessions/getVendorDetails"];
    },
  },

  data() {
    return {
      Title: "Stock Audit",
      loading: true,
      search: "",
      remarks: "",
      isHidden: false,
      customerInfo: [],
      page: 1,
      auditDetails: [],
    };
  },
  methods: {
    fetchAuditPlansList() {
      this.$loading = true;
      let url = {
        url: "/audit/list",
      };
      let data = Object.assign(url, this.vendorDetails);
      axios
        .post(data.url, data)
        .then((res) => {
          this.auditDetails = res.data.data.data;
          // this.$store.commit("stock/getPlanDetails", res.data[0].data);
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    stockAudit(data) {
      db.stock.clear();
      this.$store.commit("stock/clearGroupId");
      this.$store.commit("stock/getPlanDetails", data);
      this.$router.push("/stock-count-audit");
    },
  },
};
</script>
<style lang="scss" scoped>
.light-grey {
  color: #e0e0e0;
}
.description {
  font-size: 11px;
  color: $secondary-bg-btn;
}

.theme-light {
  .customer-info a {
    color: $body-color;
  }
}
.theme-dark {
  .light-grey {
    color: #404040;
  }
  .customer-info {
    color: $white-color;
    background-color: #202020 !important;
    a {
      color: $white-color;
    }
    .row {
      border-bottom: 1px solid #404040;
    }
  }
}
.customer-info {
  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .badge {
      font-weight: normal;
      background: $light-grey;
      color: $body-color;
      width: 13 0px;
      @include text-overflow();
    }
  }
}

.customer-data {
  height: calc(100vh - 90px);
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -15px;
  margin-right: -15px;
  @include custom-scrollbar();
}
</style>
